// extracted by mini-css-extract-plugin
module.exports = {"BlurredText":"BlurredText_BlurredText__3A11p"};